<template>
	<div class="full-width full-height">
		<div v-if="locations.length > 0">
			<div id="portfolio-header">
				<div id="portfolio-header-title" class="left text-left">
					<div class="portfolio-title">Aggregated power forecast</div>
					<div class="m-t-xs portfolio-subtitle">
						Cumulative Solar PV plants generation
						<span v-if="$store.getters.locations.length > 0"
							>({{ $store.getters.locations.length }}
							{{
								$store.getters.locations.length == 1 ? "location" : "locations"
							}})</span
						>
					</div>
				</div>

				<div v-if="forecasts" class="clear">
					<div class="right m-t-xl">
						<JsonCSV :data="export_data" :name="csv_name" class="right">
							<CustomButton text="Download forecast" />
						</JsonCSV>
						<div class="portfolio-header-data right m-r-xl">
							<div class="left m-r">
								<span>Peak</span><br /><span>production</span>
							</div>
							<div class="right">
								<span>{{ peak_production }} MW</span>
							</div>
							<div class="clear"></div>
						</div>
						<div class="portfolio-header-data right m-r-xl">
							<div class="left m-r">
								<span>Average daily</span><br /><span>production</span>
							</div>
							<div class="right">
								<span>{{ daily_average_production }} MWh</span>
							</div>
							<div class="clear"></div>
						</div>
						<div class="portfolio-header-data right m-r-xl">
							<div class="left m-r">
								<span>Total capacity</span><br />
								<span>
									({{ locations.length }} PV
									{{ locations.length == 1 ? "plant" : "plants" }})
								</span>
							</div>
							<div class="right">
								<span>{{ total_capacity }} MWp</span>
							</div>
							<div class="clear"></div>
						</div>
					</div>
					<div class="clear"></div>
					<PortfolioAgregated :forecasts="forecasts" />
					<div class="clear"></div>
					<div class="clear m-t-xl"></div>
					<PortfolioSingle :locations="locations" />
				</div>
			</div>
		</div>
		<div v-else class="no-locations-div relative m-t">
			<NoLocations />
		</div>
	</div>
</template>

<script>
import NoLocations from "@/components/sub-components/NoLocations";
import CustomButton from "@/components/sub-components/CustomButton";
import JsonCSV from "vue-json-csv";
import LocationsExportImportService from "@/services/LocationsExportImportService";
import PortfolioAgregated from "@/components/pages/portfolio/PortfolioAgregated";
import PortfolioSingle from "@/components/pages/portfolio/PortfolioSingle";

var moment = require("moment");

export default {
	name: "Portfolio",
	components: {
		CustomButton,
		JsonCSV,
		NoLocations,
		PortfolioAgregated,
		PortfolioSingle
	},
	data: function() {
		return {
			forecasts: null,
			total_capacity: null,
			daily_average_production: null,
			peak_production: null,
			export_data: null
		};
	},
	created: async function() {
		if (this.$store.getters.locations.length == 0) return;

		var result = await LocationsExportImportService.convert_locations_to_portfolio(
			this.$store.getters.locations
		);

		this.total_capacity = result.data.total_capacity;
		this.daily_average_production = result.data.daily_average_production;
		this.peak_production = result.data.peak_production;
		this.forecasts = result.data.chart_data;
		this.export_data = result.export_data;
	},
	computed: {
		csv_name: function() {
			return (
				"My_solar_plants_agregated_power_forecast_" +
				moment().format("YYYY-MM-DD") +
				".csv"
			);
		},
		locations: function() {
			return this.$store.getters.locations;
		}
	}
};
</script>

<style>
#portfolio-header {
	height: 100px;
	color: white;
}

.portfolio-title {
	font-size: 25px;
	font-weight: bold;
}
.portfolio-subtitle {
	font-size: 18px;
}

.portfolio-header-data > div:first-child span {
	font-size: 12px;
	line-height: 12px;
}
.portfolio-header-data > div:first-child {
	text-align: right;
}
.portfolio-header-data > div:nth-child(2) span {
	font-size: 22px;
	line-height: 50px;
}
#portfolio-chart {
	height: calc(100% - 100px);
}
</style>
